import { Head, router } from "@inertiajs/react"
import { NativeNavbar } from "@ruby-native/react"
import { Trash2 } from "lucide-react"

import { Button } from "@/components/ui/button"
import AppLayout from "@/layouts/app-layout"
import { editRecipePath, recipePath, recipesPath } from "@/routes"
import type { BreadcrumbItem, Recipe } from "@/types"

import RecipeForm from "./Form"

interface Props {
  recipe: Recipe
}

export default function Edit({ recipe }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Recipes", href: recipesPath() },
    { title: recipe.title, href: recipePath({ id: recipe.slug }) },
    { title: "Edit", href: editRecipePath({ id: recipe.slug }) },
  ]

  function handleDelete() {
    if (confirm("Are you sure you want to delete this recipe?")) {
      router.delete(recipePath({ id: recipe.slug }))
    }
  }

  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <NativeNavbar title={`Edit ${recipe.title}`} />
      <Head title={`Edit ${recipe.title}`} />
      <RecipeForm
        recipe={recipe}
        action={recipePath({ id: recipe.slug })}
        method="patch"
      />
      <div className="mx-auto mt-8 w-full max-w-xl border-t pt-6">
        <Button variant="destructive" size="sm" onClick={handleDelete}>
          <Trash2 className="mr-2 h-4 w-4" />
          Delete recipe
        </Button>
      </div>
    </AppLayout>
  )
}
